import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import ExportRegimeService from "../../services/exportRegimes/ExportRegimeService";
import { loadingExportRegimeDropdown } from "../../store/slices/exportRegimes/exportRegimeSlice";

export const useExportRegime = () => {
  const dispatch: AppDispatch = useDispatch();

  const { exportRegimeDropdown } = useSelector(
    (state: RootState) => state.exportRegime
  );

  const fetchExportRegimeDropdown = async (term: string) => {
    try {
      const response = await ExportRegimeService.fetchDropdown(term);

      const { data, statusCode } = response;

      if (statusCode === 200) {
        dispatch(loadingExportRegimeDropdown(data));
      }
    } catch (error) {
      console.error("Error al cargar regímenes de exportación:", error);
    }
  };

  return {
    exportRegimeDropdown,
    fetchExportRegimeDropdown,
  };
};
